import { Grid, GridItem } from 'vant'

export default {
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  name: 'HtContactTime',
  props: {
    c: Array,
    data: String
  },
  data() {
    return {
      model_: {},
      list: [
        { value: '14:00', text: '14:00' },
        { value: '15:00', text: '15:00' },
        { value: '16:00', text: '16:00' },
        { value: '17:00', text: '17:00' },
        { value: '18:00', text: '18:00' },
        { value: '19:00', text: '19:00' },
        { value: '20:00', text: '20:00' },
        { value: '21:00', text: '21:00' },
        { value: '22:00', text: '22:00' },
        { value: '23:00', text: '23:00' },
        { value: '23:59', text: '24:00' },
        { value: '01:00', text: '01:00' },
        { value: '02:00', text: '02:00' },
        { value: '03:00', text: '03:00' },
        { value: '04:00', text: '04:00' },
        { value: '05:00', text: '05:00' },
        { value: '06:00', text: '06:00' }
      ]
    }
  },
  mounted() {
  },
  methods: {
    emitClick(item) {
      this.$emit('ListenChild', item)
    }
  }
}